/**
 * @description 주문접수 및 연동 페이지
 */

import { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { Link as RouterLink } from "react-router-dom";
import SettingDefaultOrderView from "./sections/SettingDefaultOrderView";
import SettingDefaultOrderDirectView from "./sections/SettingDefaultOrderDirectView";
import { fn_receipt_set_type } from "function/FnBodyLayer";
import SettingDefaultLeftView from "views/setting/components/layouts/SettingDefaultLeftView";
import TabItem from "components/ui/TabItem";

const Link = RouterLink as any;

const SettingDefaultReceiptView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore, layerStore } = rootStore;

  useEffect(() => {
    settingStore.setSettingUseMenu("receipt");
    settingStore.setSettingView(false);
  }, [settingStore]);

  const tabsConfig = [
    {
      label: "배달앱 연동 설정",
      isActive: layerStore.getLayerReceiptSetTypeView === "receipt",
      isView: true,
      onClick: () => fn_receipt_set_type(rootStore, "receipt"),
    },
    {
      label: "주문접수 설정",
      isActive: layerStore.getLayerReceiptSetTypeView === "direct",
      isView: true,
      onClick: () => fn_receipt_set_type(rootStore, "direct"),
    },
  ];

  return (
    <>
      <div className={layerStore.getYgyConnectBtn ? "ygyConCoachMark article_setting" : "article_setting"}>
        {layerStore.getYgyConnectBtn && (
          <button className="coachMark" type="button" onClick={() => layerStore.setYgyConnectBtn(false)}></button>
        )}
        {/*왼쪽 메뉴 */}
        <SettingDefaultLeftView rootStore={rootStore} />
        <div className="section_content">
          <h3>주문접수 및 연동</h3>
          {/* 탭추가 */}
          <div className="box_tab">
            {tabsConfig.map((tab, index) => (
              <TabItem
                key={index}
                label={tab.label}
                isView={tab.isView}
                isActive={tab.isActive}
                onClick={tab.onClick}
              />
            ))}
          </div>
          <div className="close">
            <Link to="/">
              <button type="button">
                <span className="btn_order_history_close">닫기</span>
              </button>
            </Link>
          </div>
          {layerStore.getLayerReceiptSetTypeView === "receipt" ? (
            <SettingDefaultOrderView rootStore={rootStore} />
          ) : (
            <SettingDefaultOrderDirectView rootStore={rootStore} />
          )}
        </div>
      </div>
    </>
  );
};

export default inject("rootStore")(observer(SettingDefaultReceiptView));
